import { getPath } from '@/router/common'

const baseUrl = {
  title: '表格设置',
  path: 'sysMana'
}

export default [
  {
    path: getPath('GridMana', baseUrl),
    name: 'GridMana',
    component: () => import(/* webpackChunkName: "GridMana" */ '@/views/sysMana/gridMana/index.vue'),
    meta: {
      title: '表格设置'
    }
  },
  {
    path: getPath('GridMana_Edit', baseUrl),
    name: 'GridMana_Edit',
    component: () => import(/* webpackChunkName: "GridMana_Edit" */ '@/views/sysMana/gridMana_Edit/index.vue'),
    meta: {
      title: '表格设置修改'
    }
  },
  {
    path: getPath('QryColumnByArray', baseUrl),
    name: 'QryColumnByArray',
    component: () => import(/* webpackChunkName: "QryColumnByArray" */ '@/views/sysMana/qryColumnByArray/index.vue'),
    meta: {
      title: '获取数据源字段'
    }
  }
]
